import { render } from "./MobileApplicationManagement.vue?vue&type=template&id=4feb0738"
import script from "./MobileApplicationManagement.vue?vue&type=script&lang=js"
export * from "./MobileApplicationManagement.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pd-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__